import React from 'react'
import PropTypes from 'prop-types'
import { Icon } from '@nobia/zeus-components/lib/icons'
import ProductNavigationButton from './ProductNavigationButton'

const ProductNavigation = ({ links }) => (
  <>
    <ProductNavigationButton
      isDisabled={links.previous.path === '' && true}
      title={links.previous.name}
      url={links.previous.path}
    >
      <Icon type="arrow-left-carousel" width={46} height={24} />
    </ProductNavigationButton>

    <ProductNavigationButton
      isDisabled={links.next.path === '' && true}
      title={links.next.name}
      url={links.next.path}
    >
      <Icon type="arrow-right-carousel" width={46} height={24} />
    </ProductNavigationButton>
  </>
)

ProductNavigation.propTypes = {
  links: PropTypes.shape({
    previous: PropTypes.shape({
      path: PropTypes.string,
      name: PropTypes.string,
    }),
    next: PropTypes.shape({
      path: PropTypes.string,
      name: PropTypes.string,
    }),
  }).isRequired,
}

export default ProductNavigation
